import styled, { css } from 'styled-components';
import { rem } from '../../utils';
const getSize = ({ size, theme }) => rem(theme.Icon.Size[size] || theme.Icon.Size.Small);
export const StyledIcon = styled.i `
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  color: inherit;
  text-align: center;
`;
export const StyledSvg = styled.svg `
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  color: inherit;
  text-align: center;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  ${({ theme, color, highlightColor }) => css `
    ${color &&
    css `
      color: ${color};
      fill: ${color};
    `}

    ${highlightColor &&
    css `
      &:hover {
        color: ${highlightColor};
        fill: ${highlightColor};
        transition: all ${theme.Transition.Timing.In};
      }
    `}
  `}
`;
//# sourceMappingURL=Icon.style.js.map